import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';

function TraditionalMarketing() {
  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable certain keyboard shortcuts
    const handleKeyDown = (e) => {
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J')) ||
        (e.ctrlKey && e.key === 'U')
      ) {
        e.preventDefault();
        return false;
      }
    };

    // Disable text selection and copy
    const handleCopy = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable drag
    const handleDragStart = (e) => {
      e.preventDefault();
      return false;
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('copy', handleCopy);
    document.addEventListener('dragstart', handleDragStart);

    // Disable text selection via CSS
    document.body.style.userSelect = 'none';
    document.body.style.webkitUserSelect = 'none';
    document.body.style.msUserSelect = 'none';

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('dragstart', handleDragStart);
      document.body.style.userSelect = '';
      document.body.style.webkitUserSelect = '';
      document.body.style.msUserSelect = '';
    };
  }, []);

  return (
    <div className="bg-black text-white min-h-screen overflow-x-hidden w-full">
      {/* Navbar */}
      <Navbar />

      {/* Protection styles for images */}
      <style jsx>{`
        img {
          pointer-events: none;
          user-select: none;
          -webkit-user-drag: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
        }
        html, body {
          overflow-x: hidden;
          max-width: 100%;
        }
      `}</style>

      {/* Background stars effect */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        {[...Array(80)].map((_, i) => (
          <div
            key={i}
            className="absolute bg-white rounded-full opacity-50"
            style={{
              width: Math.random() * 2 + 1 + 'px',
              height: Math.random() * 2 + 1 + 'px',
              top: Math.random() * 100 + '%',
              left: Math.random() * 100 + '%',
            }}
          />
        ))}
      </div>

      {/* Hero Section - Traditional Marketing */}
      <section className="relative px-4 sm:px-8 lg:px-24 pt-20 pb-8 sm:py-8 overflow-hidden min-h-screen flex items-center">
        {/* Background Image */}
        <div className="absolute inset-0 overflow-hidden">
          <img 
            src="/Assests/traditional_marketing_hero.png" 
            alt="Traditional Marketing Background" 
            className="w-full h-full object-cover"
          />
        </div>
        
        {/* Dark overlay */}
        <div className="absolute inset-0 "></div>

        <div className="max-w-7xl mx-auto relative z-10 w-full">
          <div className="grid lg:grid-cols-2 gap-6 sm:gap-12 items-center">
            
            {/* Left Side - Content */}
            <div className="space-y-8">
              
              {/* Main Heading */}
              <h1 className="text-2xl sm:text-4xl lg:text-6xl font-bold text-white mb-6 sm:mb-8 leading-tight">
                Traditional Marketing: Timeless Strategies in a Digital World
              </h1>

              {/* Description */}
              <p className="text-gray-200 text-lg lg:text-xl leading-relaxed max-w-2xl mb-12">
                Discover how print ads, TV commercials, radio spots, billboards, and flyers continue to drive brand success in an increasingly digital landscape.
              </p>

              {/* CTA Buttons */}
              <div className="flex flex-wrap gap-3 sm:gap-4">
                <button className="px-6 sm:px-8 py-3 bg-orange-500 text-white rounded-md font-medium hover:bg-orange-600 transition">
                  Explore Traditional Marketing
                </button>
                <button className="px-8 py-3 border border-orange-500 text-orange-500 rounded-md font-medium hover:bg-orange-500 hover:text-white transition">
                  See the Future
                </button>
              </div>

            </div>

            {/* Right Side - Billboard Image */}
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden">
                <img 
                  src="/Assests/home_page_100.png" 
                  alt="Digital Billboard" 
                  className="w-full h-[350px] sm:h-[700px] object-cover"
                />
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Chapter 1: What Is Traditional Marketing Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-8 overflow-hidden">
        
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/60"></div>

        <div className="max-w-7xl mx-auto relative z-10">
          <div className="grid lg:grid-cols-3 gap-6 sm:gap-12 items-center">
            
            {/* Left Column - Content */}
            <div className="space-y-6">
              
              {/* Main Heading */}
              <h2 className="text-3xl lg:text-4xl font-bold text-white leading-tight">
                What Is Traditional Marketing?
              </h2>

              {/* First Paragraph */}
              <p className="text-gray-200 text-sm lg:text-base leading-relaxed">
                Traditional marketing encompasses offline channels like print ads, TV, radio, billboards, and flyers. It's the foundation of advertising history, connecting brands with customers in the physical world through tangible, memorable experiences.
              </p>

              {/* Second Paragraph */}
              <p className="text-gray-200 text-sm lg:text-base leading-relaxed">
                Despite digital's explosive rise, an impressive 71% of small businesses still rely on traditional marketing to reach audiences effectively, proving its enduring value and relevance in today's marketplace.
              </p>

            </div>

            {/* Middle Column - Stats */}
            <div className="text-center space-y-4">
              <h3 className="text-5xl sm:text-7xl lg:text-8xl font-bold text-white leading-none">
                71%
              </h3>
              <p className="text-xl lg:text-2xl font-semibold text-white">
                Small Businesses
              </p>
              <p className="text-gray-300 text-base">
                Still use traditional marketing channels
              </p>
            </div>

            {/* Right Column - Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src="/Assests/home_page_101.png" 
                  alt="Vintage Marketing Materials" 
                  className="w-full h-[400px] object-cover"
                />
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Section 1: The Origins - From Market Cries to Mass Media */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-8 bg-orange-500/60">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(60)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-orange-200 rounded-full opacity-30"
              style={{
                width: Math.random() * 3 + 1 + 'px',
                height: Math.random() * 3 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-6xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-black mb-10 sm:mb-16 text-center">
            The Origins: From Market Cries to Mass Media
          </h2>

            
            {/* Timeline Item 1 - Medieval Era */}
            <div className="flex items-start gap-8">
              <div className="flex-1 text-right">
                <h3 className="text-2xl font-bold text-white mb-2">Medieval Era</h3>
                <p className="text-gray-300 text-base">
                  Merchants shouting in bustling markets to attract customers
                </p>
              </div>
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-orange-300 rounded-full flex items-center justify-center text-black font-bold text-xl border-4 border-orange-600">
                  1
                </div>
                <div className="w-1 h-16 bg-orange-600"></div>
              </div>
              <div className="flex-1"></div>
            </div>

            {/* Timeline Item 2 - Industrial Revolution */}
            <div className="flex items-start gap-8">
              <div className="flex-1"></div>
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-orange-300 rounded-full flex items-center justify-center text-black font-bold text-xl border-4 border-orange-600">
                  2
                </div>
                <div className="w-1 h-16 bg-orange-600"></div>
              </div>
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-white mb-2">Industrial Revolution</h3>
                <p className="text-gray-300 text-base">
                  Print newspapers emerge as primary advertising medium
                </p>
              </div>
            </div>

            {/* Timeline Item 3 - 1920s-1950s */}
            <div className="flex items-start gap-8">
              <div className="flex-1 text-right">
                <h3 className="text-2xl font-bold text-white mb-2">1920s-1950s</h3>
                <p className="text-gray-300 text-base">
                  Radio broadcasting creates unprecedented mass reach
                </p>
              </div>
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-orange-300 rounded-full flex items-center justify-center text-black font-bold text-xl border-4 border-orange-600">
                  3
                </div>
                <div className="w-1 h-16 bg-orange-600"></div>
              </div>
              <div className="flex-1"></div>
            </div>

            {/* Timeline Item 4 - Golden Age */}
            <div className="flex items-start gap-8">
              <div className="flex-1"></div>
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-orange-300 rounded-full flex items-center justify-center text-black font-bold text-xl border-4 border-orange-600">
                  4
                </div>
                <div className="w-1 h-16 bg-orange-600"></div>
              </div>
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-white mb-2">Golden Age</h3>
                <p className="text-gray-300 text-base">
                  Television and billboards dominate the advertising landscape
                </p>
              </div>
            </div>

            {/* Timeline Item 5 - Modern Era */}
            <div className="flex items-start gap-8">
              <div className="flex-1 text-right">
                <h3 className="text-2xl font-bold text-white mb-2">Modern Era</h3>
                <p className="text-gray-300 text-base">
                  Traditional channels evolve with digital integration
                </p>
              </div>
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-orange-300 rounded-full flex items-center justify-center text-black font-bold text-xl border-4 border-orange-600">
                  5
                </div>
              </div>
              <div className="flex-1"></div>
            </div>

          
          {/* Bottom Description */}
          <p className="text-black text-lg lg:text-xl py-8 leading-relaxed text-center max-w-7xl mx-auto">
            The golden era of traditional marketing set the stage for today's trusted offline tactics. These methods built brand awareness and consumer relationships long before the internet existed, establishing principles that remain relevant today.
          </p>

        </div>
      </section>

      {/* Section 2: Why Traditional Marketing Still Matters in 2025 */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-22 ">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(60)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-orange-200 rounded-full opacity-30"
              style={{
                width: Math.random() * 3 + 1 + 'px',
                height: Math.random() * 3 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-6xl mx-auto relative z-10">
          
          {/* Content Card */}
          <div className="bg-black/80 backdrop-blur-sm rounded-3xl p-5 sm:p-12 lg:p-16">
            
            {/* Main Heading */}
            <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-8 sm:mb-12 text-center">
              Why Traditional Marketing Still Matters 
            </h2>

            {/* Grid of 4 Cards */}
            <div className="grid md:grid-cols-2 gap-4 sm:gap-6">
              
              {/* Card 1 - Local Targeting Excellence */}
              <div className="bg-orange-500/40 border-2 border-orange-500 rounded-2xl p-8 space-y-4">
                <h3 className="text-2xl font-bold text-white">
                  Local Targeting Excellence
                </h3>
                <p className="text-gray-200 text-base leading-relaxed">
                  Ideal for geographic-specific campaigns that reach communities where they live, work, and shop
                </p>
              </div>

              {/* Card 2 - Tangible Trust */}
              <div className="bg-orange-500/40 border-2 border-orange-500 rounded-2xl p-8 space-y-4">
                <h3 className="text-2xl font-bold text-white">
                  Tangible Trust
                </h3>
                <p className="text-gray-200 text-base leading-relaxed">
                  Physical ads like flyers and print materials boost credibility through touchable, lasting presence
                </p>
              </div>

              {/* Card 3 - Lasting Impressions */}
              <div className="bg-orange-500/40 border-2 border-orange-500 rounded-2xl p-8 space-y-4">
                <h3 className="text-2xl font-bold text-white">
                  Lasting Impressions
                </h3>
                <p className="text-gray-200 text-base leading-relaxed">
                  Billboards and print ads create memorable impact beyond fleeting digital content
                </p>
              </div>

              {/* Card 4 - Authenticity Appeal */}
              <div className="bg-orange-500/40 border-2 border-orange-500 rounded-2xl p-8 space-y-4">
                <h3 className="text-2xl font-bold text-white">
                  Authenticity Appeal
                </h3>
                <p className="text-gray-200 text-base leading-relaxed">
                  Millennials and Gen Z increasingly engage with traditional media for genuine connections
                </p>
              </div>

            </div>

          </div>

        </div>
      </section>

      {/* Section 3: Chapter 2 - Print Advertising */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-8 bg-orange-500/60">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-10 sm:mb-16">
            Print Advertising – More Than Just Ink on Paper
          </h2>

          {/* Two Column Layout */}
          <div className="grid lg:grid-cols-2 gap-6 sm:gap-12 mb-10 sm:mb-16">
            
            {/* Left Side - Content */}
            <div className="space-y-8">
              
              {/* What Print Includes Heading */}
              <h3 className="text-3xl font-bold text-gray-100 mb-6">
                What Print Includes
              </h3>

              {/* Bullet Points */}
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <span className="text-orange-500 text-xl mt-1">•</span>
                  <span className="text-gray-200 text-lg">Newspapers for local market penetration</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-orange-500 text-xl mt-1">•</span>
                  <span className="text-gray-200 text-lg">Magazines offering niche targeting</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-orange-500 text-xl mt-1">•</span>
                  <span className="text-gray-200 text-lg">Posters creating visual impact</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-orange-500 text-xl mt-1">•</span>
                  <span className="text-gray-200 text-lg">Direct mail flyers for personalized reach</span>
                </li>
              </ul>

              {/* Description Paragraph */}
              <p className="text-gray-200 text-lg leading-relaxed">
                Print ads enhance brand perception and encourage longer consumer engagement through physical interaction and repeated exposure.
              </p>

            </div>

            {/* Right Side - Image */}
            <div className="relative">
                <img 
                  src="/Assests/home_page_102.png" 
                  alt="Print Magazine Mockup" 
                  className="w-full h-auto object-cover rounded-2xl"
                />
            </div>

          </div>

          {/* Bottom Two Cards */}
            <div className="grid md:grid-cols-2 gap-5 sm:gap-6">
            
            {/* Card 1 - Newspapers */}
            <div className="bg-black/60 border-2 border-orange-500 rounded-2xl p-8 space-y-4 max-w-[550px] mx-auto">
                <h3 className="text-2xl font-bold text-white">Newspapers</h3>
                <p className="text-gray-200 text-base leading-relaxed">
                Complex, information-dense ads suited for local markets and detailed messaging
                </p>
            </div>

            {/* Card 2 - Magazines */}
            <div className="bg-black/60 border-2 border-orange-500 rounded-2xl p-8 space-y-4 max-w-[550px] mx-auto">
                <h3 className="text-2xl font-bold text-white">Magazines</h3>
                <p className="text-gray-200 text-base leading-relaxed">
                High-quality visuals with longer shelf life for premium brand storytelling
                </p>
            </div>

            </div>

        </div>
      </section>

      {/* Section 4: Print Advertising in Action - Case Studies */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-8 bg-orange-500/60">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-10 sm:mb-16 text-left">
            Print Advertising in Action: Case Studies
          </h2>

          {/* Three Column Cards */}
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-8">
            
            {/* Card 1 - Local Retail Success */}
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-white">
                Local Retail Success
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                Local retailers use newspaper ads to drive foot traffic, announce sales, and promote community events with measurable attendance increases.
              </p>
            </div>

            {/* Card 2 - Premium Brand Stories */}
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-white">
                Premium Brand Stories
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                High-end brands leverage glossy magazines for sophisticated product storytelling that elevates brand prestige and consumer desire.
              </p>
            </div>

            {/* Card 3 - Community Outreach */}
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-white">
                Community Outreach
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                Direct mail flyers remain highly effective for neighborhood businesses, seasonal promotions, and building local customer loyalty.
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* Section 5: The Challenges of Print */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(60)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-orange-200 rounded-full opacity-30"
              style={{
                width: Math.random() * 3 + 1 + 'px',
                height: Math.random() * 3 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-8xl mx-auto relative z-10">
          
          {/* Content Card */}
          <div className="bg-orange-500/50 backdrop-blur-sm rounded-3xl p-5 sm:p-12 lg:p-16">
            
            {/* Main Heading */}
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-12">
              The Challenges of Print
            </h2>

            {/* Grid of 3 Cards */}
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
            
            {/* Card 1 - Declining Readership */}
            <div className="bg-black/60 border-2 border-orange-500 rounded-2xl p-8 space-y-4 max-w-[600px] mx-auto">
                <h3 className="text-2xl font-bold text-white">Declining Readership</h3>
                <p className="text-gray-200 text-base leading-relaxed">
                Newspaper readership continues to drop, especially among younger demographics who prefer digital sources
                </p>
            </div>

            {/* Card 2 - High Production Costs */}
            <div className="bg-black/60 border-2 border-orange-500 rounded-2xl p-8 space-y-4 max-w-[600px] mx-auto">
                <h3 className="text-2xl font-bold text-white">High Production Costs</h3>
                <p className="text-gray-200 text-base leading-relaxed">
                Magazine ads require significant investment with long lead times for design and printing
                </p>
            </div>

            {/* Card 3 - ROI Measurement */}
            <div className="bg-black/60 border-2 border-orange-500 rounded-2xl p-8 space-y-4 max-w-[600px] mx-auto">
                <h3 className="text-2xl font-bold text-white">ROI Measurement</h3>
                <p className="text-gray-200 text-base leading-relaxed">
                Difficulty tracking precise return on investment compared to instantly measurable digital channels
                </p>
            </div>

            </div>

          </div>

        </div>
      </section>

      {/* Section 6: Chapter 3 - Television Advertising */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-8 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 overflow-hidden">
          <img 
            src="/Assests/home_page_16.png" 
            alt="Television Background" 
            className="w-full h-full object-cover"
          />
        </div>
        
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/50"></div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight max-w-8xl">
            Television Advertising – The Mass Reach Powerhouse
          </h2>

          {/* Description */}
          <p className="text-gray-200 text-lg leading-relaxed mb-12 max-w-10xl">
            Broadcast TV reaches millions of viewers simultaneously via major networks like CBS, ABC, and NBC. TV ads build brand awareness quickly with creative, attention-grabbing content that combines visual storytelling with emotional resonance.
          </p>

          {/* Three Feature Cards with Icons */}
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
            
            {/* Card 1 - Mass Reach */}
            <div className="bg-black/60 backdrop-blur-sm border-2 border-orange-500 rounded-2xl p-8 space-y-4">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <rect x="2" y="7" width="20" height="14" rx="2" strokeWidth="2"/>
                  <path d="M17 2l-5 5-5-5" strokeWidth="2"/>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-white">
                Mass Reach
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                Millions of viewers in single broadcasts
              </p>
            </div>

            {/* Card 2 - Consumer Trust */}
            <div className="bg-black/60 backdrop-blur-sm border-2 border-orange-500 rounded-2xl p-8 space-y-4">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path d="M13 10V3L4 14h7v7l9-11h-7z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-white">
                Consumer Trust
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                Highly regulated medium increases credibility
              </p>
            </div>

            {/* Card 3 - Digital Bridge */}
            <div className="bg-black/60 backdrop-blur-sm border-2 border-orange-500 rounded-2xl p-8 space-y-4">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-white">
                Digital Bridge
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                "Push" medium drives online engagement
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* Section 7: TV Advertising Today - Trends and Insights */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-16">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-orange-500 mb-10 sm:mb-16 text-center">
            TV Advertising Today: Trends and Insights
          </h2>

          {/* Two Column Layout */}
          <div className="grid lg:grid-cols-2 gap-6 sm:gap-12 mb-10 sm:mb-16">
            
            {/* Left Side - Image */}
            <div className="relative">
                <img 
                  src="/Assests/home_page_103.png" 
                  alt="Modern TV Studio" 
                  className="w-full h-[290px] object-cover rounded-2xl"
                />
            </div>

            {/* Right Side - Content */}
            <div className="space-y-8">
              
              <h3 className="text-3xl font-bold text-white">
                The Evolution Continues
              </h3>

              <p className="text-gray-200 text-base lg:text-lg leading-relaxed">
                Streaming services with ads like Netflix and Hulu keep TV commercials relevant for modern audiences. Millennials and Gen Z still watch traditional TV and accept commercials as part of the content experience.
              </p>

              <p className="text-gray-200 text-base lg:text-lg leading-relaxed">
                Combining TV ads with social media campaigns significantly boosts overall campaign effectiveness, creating a powerful multi-channel approach that amplifies reach and engagement across platforms.
              </p>

            </div>

          </div>

          {/* Bottom Two Circular Stats */}
          <div className="grid md:grid-cols-2 gap-6 sm:gap-12 max-w-4xl mx-auto">
            
            {/* Stat 1 - 85% TV + Social Media */}
            <div className="text-center space-y-1">
              <div className="relative inline-flex items-center justify-center">
                <svg className="w-48 h-48 transform -rotate-90">
                  <circle
                    cx="96"
                    cy="96"
                    r="88"
                    stroke="#333"
                    strokeWidth="12"
                    fill="none"
                  />
                  <circle
                    cx="96"
                    cy="96"
                    r="88"
                    stroke="#f97316"
                    strokeWidth="12"
                    fill="none"
                    strokeDasharray="553"
                    strokeDashoffset="83"
                    strokeLinecap="round"
                  />
                </svg>
                <div className="absolute">
                  <span className="text-5xl font-bold text-white">85%</span>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-white">
                TV + Social Media
              </h3>
              <p className="text-gray-300 text-base">
                Increased effectiveness with integrated campaigns
              </p>
            </div>

            {/* Stat 2 - 67% Streaming Ads */}
            <div className="text-center space-y-1">
              <div className="relative inline-flex items-center justify-center">
                <svg className="w-48 h-48 transform -rotate-90">
                  <circle
                    cx="96"
                    cy="96"
                    r="88"
                    stroke="#333"
                    strokeWidth="12"
                    fill="none"
                  />
                  <circle
                    cx="96"
                    cy="96"
                    r="88"
                    stroke="#f97316"
                    strokeWidth="12"
                    fill="none"
                    strokeDasharray="553"
                    strokeDashoffset="183"
                    strokeLinecap="round"
                  />
                </svg>
                <div className="absolute">
                  <span className="text-5xl font-bold text-white">67%</span>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-white">
                Streaming Ads
              </h3>
              <p className="text-gray-300 text-base">
                Younger audiences receptive to TV commercials
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* Section 8: Chapter 4 - Radio Advertising */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-8">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Two Column Layout */}
          <div className="grid lg:grid-cols-2 gap-6 sm:gap-12 items-center">
            
            {/* Left Side - Image */}
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden">
                <img 
                  src="/Assests/home_page_104.png" 
                  alt="Radio Studio Microphone" 
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>

            {/* Right Side - Content */}
            <div className="space-y-8">
              
              {/* Main Heading */}
              <h2 className="text-4xl lg:text-5xl font-bold text-white leading-tight">
                Radio Advertising – The Unskippable Companion
              </h2>

              {/* Cards Grid */}
              <div className="grid gap-6">
                
                {/* Card 1 - Universal Reach */}
                <div className="bg-transparent border-2 border-orange-500 rounded-2xl p-6 space-y-3">
                  <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                    <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-white">
                    Universal Reach
                  </h3>
                  <p className="text-gray-300 text-base leading-relaxed">
                    Radio reaches nearly every American daily via AM/FM, satellite, and internet radio platforms
                  </p>
                </div>

                {/* Card 2 - Cost-Effective */}
                <div className="bg-transparent border-2 border-orange-500 rounded-2xl p-6 space-y-3">
                  <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                    <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-white">
                    Cost-Effective
                  </h3>
                  <p className="text-gray-300 text-base leading-relaxed">
                    Low-cost, efficient advertising creates strong local and national brand presence
                  </p>
                </div>

                {/* Card 3 - Audio Branding (Full Width) */}
                <div className="bg-transparent border-2 border-orange-500 rounded-2xl p-6 space-y-3">
                  <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                    <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-white">
                    Audio Branding
                  </h3>
                  <p className="text-gray-300 text-base leading-relaxed">
                    Radio jingles and spots build powerful brand recall through repetition and memorable melodies
                  </p>
                </div>

              </div>

            </div>

          </div>

        </div>
      </section>

      {/* Section 9: Radio's Unique Strengths and Modern Adaptations */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-8 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 overflow-hidden">
          <img 
            src="/Assests/home_page_105.png" 
            alt="Car Radio Dashboard" 
            className="w-full h-full object-cover"
          />
        </div>
        
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/60"></div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-12">
            Radio's Unique Strengths and Modern Adaptations
          </h2>

          {/* Content Card with 3 Columns */}
          <div className="bg-black/60 backdrop-blur-sm rounded-3xl p-5 sm:p-10 border border-orange-500/30">
            
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-8">
              
              {/* Column 1 - Terrestrial Radio */}
              <div className="space-y-4">
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-gray-400 text-sm font-semibold">01</span>
                  <div className="h-px flex-1 bg-orange-500"></div>
                </div>
                <h3 className="text-2xl font-bold text-white">
                  Terrestrial Radio
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Remains vital for local targeting, community connections, and regional brand building with trusted on-air personalities
                </p>
              </div>

              {/* Column 2 - Satellite Radio */}
              <div className="space-y-4">
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-gray-400 text-sm font-semibold">02</span>
                  <div className="h-px flex-1 bg-orange-500"></div>
                </div>
                <h3 className="text-2xl font-bold text-white">
                  Satellite Radio
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Expands reach to niche audiences nationwide with specialized programming and commercial-free options for premium content
                </p>
              </div>

              {/* Column 3 - Internet Radio */}
              <div className="space-y-4">
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-gray-400 text-sm font-semibold">03</span>
                  <div className="h-px flex-1 bg-orange-500"></div>
                </div>
                <h3 className="text-2xl font-bold text-white">
                  Internet Radio
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Integration with digital platforms enhances campaign tracking, real-time analytics, and precise audience engagement measurement
                </p>
              </div>

            </div>

          </div>

        </div>
      </section>

      {/* Section 10: Chapter 5 - Billboards and Out-of-Home Advertising */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-8">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Two Column Layout */}
          <div className="grid lg:grid-cols-2 gap-6 sm:gap-12 items-center mb-8 sm:mb-12">
            
            {/* Left Side - Image */}
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden">
                <img 
                  src="/Assests/home_page_106.png" 
                  alt="Highway Billboard" 
                  className="w-full h-[500px] object-cover"
                />
              </div>
            </div>

            {/* Right Side - Content */}
            <div className="space-y-8">
              
              {/* Main Heading */}
              <h2 className="text-4xl lg:text-5xl font-bold text-white leading-tight">
                Billboards and Out-of-Home Advertising – Bold and Unavoidable
              </h2>

              {/* Description */}
              <p className="text-gray-200 text-lg leading-relaxed">
                Billboards, transit ads, park benches, and digital displays dominate public spaces with unavoidable visibility. Location-based targeting offers constant exposure to commuters and pedestrians throughout their daily routines.
              </p>

            </div>

          </div>

          {/* Three Stats */}
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-8 mb-8 sm:mb-12">
            
            {/* Stat 1 - 23% Revenue Growth */}
            <div className="text-center space-y-4">
              <h3 className="text-4xl sm:text-6xl lg:text-7xl font-bold text-orange-500">
                23%
              </h3>
              <p className="text-xl font-semibold text-white">
                Revenue Growth
              </p>
              <p className="text-gray-300 text-base leading-relaxed">
                Out-of-home ad revenue increase over past decade
              </p>
            </div>

            {/* Stat 2 - 24/7 Constant Visibility */}
            <div className="text-center space-y-4">
              <h3 className="text-4xl sm:text-6xl lg:text-7xl font-bold text-orange-500">
                24/7
              </h3>
              <p className="text-xl font-semibold text-white">
                Constant Visibility
              </p>
              <p className="text-gray-300 text-base leading-relaxed">
                Round-the-clock brand exposure in high-traffic areas
              </p>
            </div>

            {/* Stat 3 - 1000s Daily Impressions */}
            <div className="text-center space-y-4">
              <h3 className="text-4xl sm:text-6xl lg:text-7xl font-bold text-orange-500">
                1000s
              </h3>
              <p className="text-xl font-semibold text-white">
                Daily Impressions
              </p>
              <p className="text-gray-300 text-base leading-relaxed">
                Potential views per billboard location daily
              </p>
            </div>

          </div>

          {/* Bottom Description */}
          <p className="text-gray-200 text-lg leading-relaxed max-w-5xl mx-auto text-center">
            Creative innovations like interactive and digital billboards dramatically increase engagement, allowing real-time content updates and dynamic messaging that responds to weather, time, or events.
          </p>

        </div>
      </section>

      {/* Section 11: Iconic Billboard Campaigns and Their Impact */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-8">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-orange-500 mb-10 sm:mb-16 text-center">
            Iconic Billboard Campaigns and Their Impact
          </h2>

          {/* Three Column Cards with Images */}
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-8">
            
            {/* Card 1 - Mass Brand Visibility */}
            <div className="space-y-6">
              <div className="relative rounded-2xl overflow-hidden">
                <img 
                  src="/Assests/home_page_107.png" 
                  alt="Coca-Cola Billboard" 
                  className="w-full h-32 object-cover rounded-lg"
                />
              </div>
              <h3 className="text-2xl font-bold text-white">
                Mass Brand Visibility
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                Coca-Cola and Apple's legendary billboard strategies demonstrate the power of simple, bold creative in dominating public consciousness
              </p>
            </div>

            {/* Card 2 - Geographic Dominance */}
            <div className="space-y-6">
              <div className="relative rounded-2xl overflow-hidden">
                <img 
                  src="/Assests/home_page_108.png" 
                  alt="Local Business Billboard" 
                  className="w-full h-32 object-cover rounded-lg"
                />
              </div>
              <h3 className="text-2xl font-bold text-white">
                Geographic Dominance
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                Local businesses use billboards strategically to establish market leadership within specific territories and communities
              </p>
            </div>

            {/* Card 3 - Digital Integration */}
            <div className="space-y-6">
              <div className="relative rounded-2xl overflow-hidden">
                <img 
                  src="/Assests/home_page_109.png" 
                  alt="Digital Billboard with QR Code" 
                  className="w-full h-32 object-cover rounded-lg"
                />
              </div>
              <h3 className="text-2xl font-bold text-white">
                Digital Integration
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                Social media hashtags and QR codes on billboards successfully bridge offline visibility with online engagement and tracking
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* Section 12: Chapter 6 - Flyers and Promotional Materials */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-8 bg-orange-500/60">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(60)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-orange-200 rounded-full opacity-30"
              style={{
                width: Math.random() * 3 + 1 + 'px',
                height: Math.random() * 3 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-10 sm:mb-16">
            Flyers and Promotional Materials – The Personal Touch
          </h2>

          {/* Two Column Layout */}
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            
            {/* Left Side - Image */}
            <div className="relative">
                <img 
                  src="/Assests/home_page_110.png" 
                  alt="Promotional Flyer" 
                  className="w-full h-[400px] object-cover rounded-2xl"
                />
            </div>

            {/* Right Side - Content */}
            <div className="space-y-8">
              
              <h3 className="text-3xl font-bold text-black">
                Tangible Communication
              </h3>

              <p className="text-black text-base lg:text-lg leading-relaxed">
                Flyers, brochures, and business cards provide tangible, direct communication that recipients can hold, save, and reference later. Ideal for events, local promotions, and face-to-face marketing interactions.
              </p>

              <p className="text-black text-base lg:text-lg leading-relaxed">
                Physical materials enhance trust and brand recall through tactile experience, creating memorable multi-sensory connections that digital media cannot replicate.
              </p>

            </div>

          </div>

          {/* Three Column Features */}
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-8">
            
            {/* Feature 1 - Events and Conferences */}
            <div className="space-y-4">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-2 h-2 bg-black rounded-full"></div>
                <h3 className="text-xl font-bold text-black">
                  Events and Conferences
                </h3>
              </div>
              <p className="text-black text-base leading-relaxed">
                Program guides, handouts, and takeaway materials keep your brand top-of-mind long after the event ends.
              </p>
            </div>

            {/* Feature 2 - Local Promotions */}
            <div className="space-y-4">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-2 h-2 bg-black rounded-full"></div>
                <h3 className="text-xl font-bold text-black">
                  Local Promotions
                </h3>
              </div>
              <p className="text-black text-base leading-relaxed">
                Door-to-door distribution, bulletin boards, and community centers offer hyper-local targeting at low cost.
              </p>
            </div>

            {/* Feature 3 - Face-to-Face Marketing */}
            <div className="space-y-4">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-2 h-2 bg-black rounded-full"></div>
                <h3 className="text-xl font-bold text-black">
                  Face-to-Face Marketing
                </h3>
              </div>
              <p className="text-black text-base leading-relaxed">
                Leave-behind materials during sales calls, meetings, or networking provide physical brand reminders.
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* Section 13: Flyers in the Digital Age */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-8">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-5xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-10 sm:mb-16 text-center">
            Flyers in the Digital Age
          </h2>

          {/* Connected Boxes Layout */}
          <div className="relative">
            
            {/* Top Row - 2 Connected Boxes */}
            <div className="grid grid-cols-2 gap-0">
              
              {/* Box 1 - QR Code Integration (Top Left) */}
              <div className="bg-transparent border-2 border-orange-500 border-r-0 rounded-tl-2xl p-8 space-y-4">
                <h3 className="text-xl font-bold text-white">
                  QR Code Integration
                </h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  Combining flyers with QR codes drives online traffic, enables campaign tracking, and delivers measurable responses from physical distribution
                </p>
              </div>

              {/* Box 2 - Grassroots Campaigns (Top Right) */}
              <div className="bg-transparent border-2 border-orange-500 rounded-tr-2xl p-8 space-y-4">
                <h3 className="text-xl font-bold text-white">
                  Grassroots Campaigns
                </h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  Flyers remain essential for community marketing, local events, political campaigns, and nonprofit awareness initiatives
                </p>
              </div>

            </div>

            {/* Bottom Row - 1 Full Width Connected Box */}
            <div className="bg-transparent border-2 border-orange-500 border-t-0 rounded-b-2xl p-8 space-y-4">
              <h3 className="text-xl font-bold text-white text-center">
                Small Business Staple
              </h3>
              <p className="text-gray-300 text-sm leading-relaxed text-center">
                Small businesses rely on flyers for cost-effective, highly targeted outreach within specific neighborhoods and demographics
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* Section 14: Benefits of Traditional Marketing Channels */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-8">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-10 sm:mb-16 text-left">
            Benefits of Traditional Marketing Channels
          </h2>

          {/* Two Column Grid - 4 Benefits */}
          <div className="grid md:grid-cols-2 gap-6 sm:gap-12">
            
            {/* Benefit 1 - Credibility and Trust */}
            <div className="space-y-6">
              <div className="w-16 h-16 border-2 border-orange-500 rounded-2xl flex items-center justify-center">
                <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-white">
                Credibility and Trust
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                Physical presence builds consumer confidence. Traditional media's tangible nature creates psychological trust that purely digital campaigns struggle to achieve.
              </p>
            </div>

            {/* Benefit 2 - Broader Demographics */}
            <div className="space-y-6">
              <div className="w-16 h-16 border-2 border-orange-500 rounded-2xl flex items-center justify-center">
                <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-white">
                Broader Demographics
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                Reaches audiences less accessible via digital means, including older demographics, rural communities, and those with limited internet access.
              </p>
            </div>

            {/* Benefit 3 - Multi-Sensory Experience */}
            <div className="space-y-6">
              <div className="w-16 h-16 border-2 border-orange-500 rounded-2xl flex items-center justify-center">
                <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-white">
                Multi-Sensory Experience
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                Creates rich brand experiences through visual design, tactile materials, and auditory elements that engage multiple senses simultaneously.
              </p>
            </div>

            {/* Benefit 4 - Omnichannel Power */}
            <div className="space-y-6">
              <div className="w-16 h-16 border-2 border-orange-500 rounded-2xl flex items-center justify-center">
                <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-white">
                Omnichannel Power
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                Complements digital marketing perfectly for holistic, omnichannel strategies that maximize reach, frequency, and conversion across all touchpoints.
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* Section 15: Limitations and Challenges */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-8 bg-orange-500/60">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(60)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-orange-200 rounded-full opacity-30"
              style={{
                width: Math.random() * 3 + 1 + 'px',
                height: Math.random() * 3 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-5xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-4xl lg:text-5xl font-bold text-black mb-8">
            Limitations and Challenges
          </h2>

          {/* Three Numbered Cards */}
          <div className="space-y-6">
            
            {/* Card 1 - Higher Investment Required */}
            <div className="bg-white/80 rounded-2xl p-8 flex gap-6 items-start">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-black/20 rounded-lg flex items-center justify-center">
                  <span className="text-3xl font-bold text-black">1</span>
                </div>
              </div>
              <div className="space-y-3">
                <h3 className="text-2xl font-bold text-black">
                  Higher Investment Required
                </h3>
                <p className="text-black text-base leading-relaxed">
                  Traditional channels typically demand higher upfront costs and less precise targeting capabilities compared to digital's granular audience segmentation and lower entry barriers.
                </p>
              </div>
            </div>

            {/* Card 2 - Measurement Complexity */}
            <div className="bg-white/80 rounded-2xl p-8 flex gap-6 items-start">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-black/20 rounded-lg flex items-center justify-center">
                  <span className="text-3xl font-bold text-black">2</span>
                </div>
              </div>
              <div className="space-y-3">
                <h3 className="text-2xl font-bold text-black">
                  Measurement Complexity
                </h3>
                <p className="text-black text-base leading-relaxed">
                  Difficult to measure real-time ROI, attribution, and campaign performance. Adjusting messaging mid-campaign is costly or impossible once materials are produced and distributed.
                </p>
              </div>
            </div>

            {/* Card 3 - Audience Fragmentation */}
            <div className="bg-white/80 rounded-2xl p-8 flex gap-6 items-start">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-black/20 rounded-lg flex items-center justify-center">
                  <span className="text-3xl font-bold text-black">3</span>
                </div>
              </div>
              <div className="space-y-3">
                <h3 className="text-2xl font-bold text-black">
                  Audience Fragmentation
                </h3>
                <p className="text-black text-base leading-relaxed">
                  Media consumption habits have splintered across countless channels. Reaching mass audiences requires careful media mix planning, strategic placement, and often significant budget allocation.
                </p>
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* Section 16: The Best of Both Worlds - Integrating Traditional and Digital */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-8 bg-black">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6 text-center">
            The Best of Both Worlds: Integrating Traditional and Digital
          </h2>

          {/* Subheading */}
          <h3 className="text-2xl lg:text-3xl font-bold text-orange-500 mb-8 text-center">
            Hybrid Campaigns Drive Superior Results
          </h3>

          {/* Description */}
          <p className="text-gray-200 text-lg leading-relaxed mb-16 text-center max-w-5xl mx-auto">
            Successful modern marketing strategies blend traditional and digital channels for amplified reach and engagement. QR codes on direct mail connect physical touchpoints to digital experiences, while billboards drive social media conversations.
          </p>

          {/* Integration Flow Diagram */}
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            
            {/* Card 1 - TV Advertising → Social Amplification */}
            <div className="bg-gradient-to-r from-orange-500/20 to-transparent border-2 border-orange-500 rounded-2xl p-8 space-y-4">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <rect x="2" y="7" width="20" height="14" rx="2" strokeWidth="2"/>
                  </svg>
                </div>
                <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path d="M17 8l4 4m0 0l-4 4m4-4H3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-black" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/>
                  </svg>
                </div>
              </div>
              <h4 className="text-2xl font-bold text-white">
                TV Advertising → Social Amplification
              </h4>
              <p className="text-gray-300 text-base leading-relaxed">
                Broadcast commercials build mass awareness, then social media extends and amplifies TV messaging to create viral conversations and deeper engagement
              </p>
            </div>

            {/* Card 2 - Print Materials → Online Conversion */}
            <div className="bg-gradient-to-l from-orange-500/20 to-transparent border-2 border-orange-500 rounded-2xl p-8 space-y-4">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path d="M17 8l4 4m0 0l-4 4m4-4H3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
              <h4 className="text-2xl font-bold text-white">
                Print Materials → Online Conversion
              </h4>
              <p className="text-gray-300 text-base leading-relaxed">
                Flyers and brochures with QR codes drive traffic to digital properties where interested viewers convert into customers through optimized landing pages
              </p>
            </div>

            {/* Card 3 - Billboard Ads → Social Media Buzz */}
            <div className="bg-gradient-to-r from-orange-500/20 to-transparent border-2 border-orange-500 rounded-2xl p-8 space-y-4">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path d="M17 8l4 4m0 0l-4 4m4-4H3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
              <h4 className="text-2xl font-bold text-white">
                Billboard Ads → Social Media Buzz
              </h4>
              <p className="text-gray-300 text-base leading-relaxed">
                Eye-catching outdoor advertising with hashtags drives social media conversations, user-generated content, and organic brand visibility online
              </p>
            </div>

            {/* Card 4 - Radio Spots → Digital Tracking */}
            <div className="bg-gradient-to-l from-orange-500/20 to-transparent border-2 border-orange-500 rounded-2xl p-8 space-y-4">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path d="M17 8l4 4m0 0l-4 4m4-4H3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
              <h4 className="text-2xl font-bold text-white">
                Radio Spots → Digital Tracking
              </h4>
              <p className="text-gray-300 text-base leading-relaxed">
                Radio ads with unique promo codes or URLs enable precise performance tracking and attribution while driving listeners to measurable digital actions
              </p>
            </div>

          </div>

          {/* Bottom Insight Box */}
          <div className="bg-orange-500/20 border-2 border-orange-500 rounded-2xl p-10 text-center">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M13 10V3L4 14h7v7l9-11h-7z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h4 className="text-2xl font-bold text-white mb-4">
              Data-Driven Insights Optimize Everything
            </h4>
            <p className="text-gray-200 text-lg leading-relaxed max-w-4xl mx-auto">
              Performance data from digital channels optimizes traditional media purchases for better performance, audience targeting, and return on investment across the entire marketing ecosystem. This closed-loop approach maximizes efficiency and ROI.
            </p>
          </div>

        </div>
      </section>

      {/* Section 17: Future Outlook - Traditional Marketing in 2025 and Beyond */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-8 bg-black">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-6xl font-bold text-white mb-10 sm:mb-20 text-center">
            Future Outlook: Traditional Marketing  and Beyond
          </h2>

          {/* Horizontal Arrow Flow */}
          <div className="flex flex-col lg:flex-row items-center justify-center gap-6 lg:gap-0">
            
            {/* Box 1 - Digital Enhancement */}
            <div className="relative">
              <div className="bg-transparent border-2 border-orange-500 rounded-2xl p-8 w-full lg:w-80 min-h-[280px] flex flex-col justify-between">
                <div className="space-y-4">
                  <h3 className="text-2xl font-bold text-white">
                    Digital Enhancement
                  </h3>
                  <p className="text-gray-300 text-base leading-relaxed">
                    Traditional media evolves with digital enhancements, interactive elements, and creative innovations that merge physical and digital experiences seamlessly.
                  </p>
                </div>
              </div>
              {/* Arrow pointing right */}
              <div className="hidden lg:block absolute -right-16 top-1/2 transform -translate-y-1/2">
                <svg className="w-32 h-32 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path d="M13 7l5 5m0 0l-5 5m5-5H6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              {/* Arrow pointing down for mobile */}
              <div className="lg:hidden flex justify-center my-6">
                <svg className="w-16 h-16 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path d="M19 14l-7 7m0 0l-7-7m7 7V3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>

            {/* Spacer for arrow */}
            <div className="hidden lg:block w-32"></div>

            {/* Box 2 - Local Business Vitality */}
            <div className="relative">
              <div className="bg-transparent border-2 border-orange-500 rounded-2xl p-8 w-full lg:w-80 min-h-[280px] flex flex-col justify-between">
                <div className="space-y-4">
                  <h3 className="text-2xl font-bold text-white">
                    Local Business Vitality
                  </h3>
                  <p className="text-gray-300 text-base leading-relaxed">
                    Continued relevance for local businesses, community brand building, and geographically targeted mass awareness campaigns that digital alone cannot achieve.
                  </p>
                </div>
              </div>
              {/* Arrow pointing right */}
              <div className="hidden lg:block absolute -right-16 top-1/2 transform -translate-y-1/2">
                <svg className="w-32 h-32 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path d="M13 7l5 5m0 0l-5 5m5-5H6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              {/* Arrow pointing down for mobile */}
              <div className="lg:hidden flex justify-center my-6">
                <svg className="w-16 h-16 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path d="M19 14l-7 7m0 0l-7-7m7 7V3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>

            {/* Spacer for arrow */}
            <div className="hidden lg:block w-32"></div>

            {/* Box 3 - Authenticity Rediscovered */}
            <div className="relative">
              <div className="bg-transparent border-2 border-orange-500 rounded-2xl p-8 w-full lg:w-80 min-h-[280px] flex flex-col justify-between">
                <div className="space-y-4">
                  <h3 className="text-2xl font-bold text-white">
                    Authenticity Rediscovered
                  </h3>
                  <p className="text-gray-300 text-base leading-relaxed">
                    Younger generations increasingly rediscover print media and traditional TV for authenticity, trust, and escape from digital overload and misinformation.
                  </p>
                </div>
              </div>
            </div>

          </div>

          {/* Bottom Summary */}
          <div className="mt-20 text-center max-w-5xl mx-auto">
            <div className="bg-orange-500/20 border-2 border-orange-500 rounded-2xl p-10">
              <h3 className="text-3xl font-bold text-white mb-6">
                The Evolution of Traditional Marketing
              </h3>
              <p className="text-gray-200 text-lg leading-relaxed">
                Traditional marketing channels are not disappearing—they're evolving. By embracing digital enhancements, maintaining local relevance, and offering authentic experiences, traditional media continues to play a vital role in the marketing mix. The future belongs to integrated strategies that leverage the unique strengths of both worlds.
              </p>
            </div>
          </div>

        </div>
      </section>

      {/* Section 18: Conclusion - Harnessing the Power of Traditional Marketing Today */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-8 bg-black">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          <div className="grid lg:grid-cols-2 gap-6 sm:gap-12 items-center">
            
            {/* Left Side - Content */}
            <div className="space-y-8">
              
              {/* Main Heading */}
              <h2 className="text-4xl lg:text-5xl font-bold text-white leading-tight">
                Conclusion: Harnessing the Power of Traditional Marketing Today
              </h2>

              {/* Paragraph 1 */}
              <p className="text-gray-200 text-lg leading-relaxed">
                Traditional marketing remains a vital, effective tool in every marketer's arsenal. When combined thoughtfully with digital strategies, it creates powerful, memorable campaigns that drive real business results.
              </p>

              {/* Paragraph 2 */}
              <p className="text-gray-200 text-lg leading-relaxed">
                Invest wisely in print ads, TV commercials, radio spots, billboards, and flyers to connect deeply with your audience. These time-tested channels continue to deliver credibility, reach, and tangible impact that digital alone cannot match.
              </p>

              {/* Paragraph 3 with Bold */}
              <p className="text-gray-200 text-lg leading-relaxed">
                <span className="text-white font-semibold">Ready to elevate your brand?</span> Explore how traditional marketing can work synergistically with your digital efforts to create comprehensive campaigns that resonate across all customer touchpoints.
              </p>

              {/* CTA Buttons */}
              <div className="flex flex-wrap gap-4 pt-4">
                <button className="px-8 py-4 bg-orange-500 text-black font-semibold rounded-lg hover:bg-orange-600 transition-all transform hover:scale-105">
                  Get Started with Gamma
                </button>
                <button className="px-8 py-4 bg-transparent border-2 border-orange-500 text-orange-500 font-semibold rounded-lg hover:bg-orange-500 hover:text-black transition-all transform hover:scale-105">
                  Review Key Insights
                </button>
              </div>

            </div>

            {/* Right Side - Image */}
            <div className="relative flex justify-center lg:justify-end">
              <div className="relative rounded-3xl overflow-hidden bg-gray-800 w-full max-w-md">
                <img 
                  src="/Assests/home_page_27.png" 
                  alt="Traditional Marketing Power" 
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>

          </div>

        </div>
      </section>

    </div>
  );
}

export default TraditionalMarketing;